module.exports = __webpack_public_path__ + "img/9.131db670.jpg";